export default __webpack_public_path__ + "static/media/uploader-tandem-problem-2.a059fc85.png";